export default function startCase(value) {
  if (!value || value.length === 0) {
    return '';
  }
  const title = value
    .replace(/([A-Z])/g, function(match) {
      return ' ' + match;
    })
    .replace(/([_|-]\w)/g, function(match) {
      return ' ' + match[1].toUpperCase();
    })
    .replace(/ \w/g, function(match) {
      return match.toUpperCase();
    });

  return title[0].toUpperCase() + title.slice(1);
}
